module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6Frmr"))).then(() => module.bundle.root('dsisd'));